import React from 'react';

import { DiscountListComponent } from '../../../discount/DiscountListComponent';
import { hasCashback, isMultiDiscount } from '../../../../services/partner/utils';

import './ModalMultiDiscountComponent.scss';

export const ModalMultiDiscountComponent = ({ partner, discounts, REFUND }) => {
    if (isMultiDiscount(partner) && hasCashback(partner) && discounts) {
        return (
            <div className="metadata-multidiscounts">
                <DiscountListComponent discounts={discounts} />
            </div>
        );
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalMultiDiscountComponent.js